'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './banking-accounts-list.routes';

export class BankingAccountsListComponent {
  constructor(Auth, BankingAccountsService, dialogs, $uibModal, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.Auth = Auth;
    this.BankingAccountsService = BankingAccountsService;
    this.$uibModal = $uibModal;

    this.loadData();

  }

  loadData() {
    this.isLoading = true;
    this.isLoadingHistory = true;
    this.Auth.getCurrentUser(user => {

      this.BankingAccountsService.getByUser(data => {
        this.accounts = data;
        this.isLoading = false;
      }, err => {
        this.isLoading = false;
        this.isError = true;
      });

      this.BankingAccountsService.getPaymentsByUser(data => {
        this.payments = data;
        this.isLoadingHistory = false;
      }, err => {
        this.isLoadingHistory = false;
        this.isErrorHistory = true;
      })
    });
  }

  delete(account) {
    var that = this;

    var dlg = this.dialogs.confirm("Delete Banking Account?", "Do you really want to delete the banking account?" +
      "<br/><br/><b>" + account.account_holder_name +  ", ***" + account.last4 + " ("+ account.bank_name +")" + "</b>");
    dlg.result.then(() => {
      that.BankingAccountsService.delete({customer: account.customer, id: account.id},
        () => {
          that.loadData();
        },
        err => {
          alert("Could not delete banking account");
        });
    }, () => {
      // Cancel
    });
  }

  verify(account) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'md',
      component: 'bankingAccountVerification',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (amounts) {

        that.BankingAccountsService.verify({customer: account.customer, id: account.id},{amounts}, _ => {
          that.loadData();
          that.dialogs.notify("Verification Success","Your Banking Account has been successfully verified.<br/>You can now use the account to process ACH payments");
        }, err => {
          that.dialogs.error("Verification Failed", "The micro payments you entered are not correct.");
        });
      },
      function () { /* cancel */ }
    );
  }

}

export default angular.module('conduuApp.bankingAccountsList', [uiRouter])
  .config(routes)
  .component('bankingAccountsList', {
    template: require('./banking-accounts-list.html'),
    controller: BankingAccountsListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/banking-accounts/list/banking-accounts-list.component.js